import { CommonSymbolsFactory } from '@/containers/symbols/factory/CommonSymbolsFactory'
import { ScatterSymbolsFactory } from '@/containers/symbols/factory/ScatterSymbolsFactory'
import { MultiplierSymbolsFactory } from '@/containers/symbols/factory/MultiplierSymbolsFactory'
import { SpecialSymbolType } from '@/containers/symbols/SpecialSymbolType'
import { SymbolType } from '@/containers/symbols/SymbolType'
import * as PIXI from 'pixi.js'
import { SymbolSpineAnimation } from '../SymbolSpineAnimation'
import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'
import { LowValueSymbolsFactory } from '@/containers/symbols/factory/LowValueSymbolsFactory'

export class SymbolsAnimationFactoryAdapter {
    private readonly _poolMap: Record<number, SymbolsAnimationFactory>

    public constructor() {
        this._poolMap = {}

        this._poolMap[SpecialSymbolType.MULTIPLIER] = new MultiplierSymbolsFactory()
        this._poolMap[SpecialSymbolType.SCATTER] = new ScatterSymbolsFactory()

        this._poolMap[SymbolType.HP_4] = new CommonSymbolsFactory('HV4', { land: 'landing', win: 'win', out: 'out' })
        this._poolMap[SymbolType.HP_3] = new CommonSymbolsFactory('HV3', { land: 'landing', win: 'win', out: 'out' })
        this._poolMap[SymbolType.HP_2] = new CommonSymbolsFactory('HV2', { land: 'landing', win: 'win', out: 'out' })
        this._poolMap[SymbolType.HP_1] = new CommonSymbolsFactory('HV1', { land: 'landing', win: 'win', out: 'out' })

        this._poolMap[SymbolType.LP_5] = new LowValueSymbolsFactory()
        this._poolMap[SymbolType.LP_4] = new LowValueSymbolsFactory()
        this._poolMap[SymbolType.LP_3] = new LowValueSymbolsFactory()
        this._poolMap[SymbolType.LP_2] = new LowValueSymbolsFactory()
        this._poolMap[SymbolType.LP_1] = new LowValueSymbolsFactory()
    }

    public out(parent: PIXI.Container, symbolData: SymbolContainerData): SymbolSpineAnimation {
        let index: number = symbolData.index

        let pool = this._poolMap[index]

        if (pool != null) {
            return pool.out(parent, symbolData)
        }

        return null
    }

    public in(item: SymbolSpineAnimation) {
        return item.pool.in(item)
    }
}
